import ApiFactory from '@/factories/ApiFactory'
import {serialize} from '@/utilities/querySerialize'

export default {
  list(query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/projects?${serialize(query)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  details(id) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/projects/${id}?include=client,manager`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  create(payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/projects', payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  update(payload) {
    return new Promise((resolve, reject) => {
      let id = payload.id
      ApiFactory.put(`v1/projects/${id}`, payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/projects/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getManagers() {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/projects/actions/getManagers`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getCurrencies() {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/projects/actions/currencies`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getPerformance(projectId) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/projects/${projectId}/actions/performance`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getUsers(projectId) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/projects/${projectId}/actions/getUsers?include=roles`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  addUser(payload) {
    let {projectId, userId} = payload
    return new Promise((resolve, reject) => {
      ApiFactory.post(`v1/projects/${projectId}/actions/addUser${userId}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  addBulkUsers(payload) {
    let {projectId, users} = payload
    return new Promise((resolve, reject) => {
      ApiFactory.post(`v1/projects/${projectId}/actions/bulkAddUsers`, users)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  removeUser(payload) {
    let {projectId, userId} = payload
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/projects/${projectId}/actions/removeUser/${userId}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
}
